<template>
  <Modal
    :id="'cmp-settings-task-template-form'"
    @cancelled="onCancel"
    :loadingFlag="loadingFlag"
  >
    <template slot="header"
      >{{$t('add_task_template')}}</template
    >

    <template slot="body">
      <div class="form-group">
        <!-- {{ assignedUserSelectedTV }}
        {{ localDetailsTypeSelectedTV }} -->
        <TextField
          class="m1"
          :id="'task_template_name'"
          v-bind="textFieldConfig"
          :value="task_template.task_template_name"
          :placeholder="$t('task_template_name')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'day_shift'"
          v-bind="textFieldConfig"
          :value="task_template.day_shift"
          :placeholder="$t('day_shift')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <Dropdown
          :options="usersTV"
          class="m2"
          :selected="assignedUserSelectedTV"
          :placeholder="$t('assigned_user')"
          v-on:selectedChange="e => onDropdownChange('assigned_user', e)"
          :listHeight="120"
          box
          multiple
        ></Dropdown>
        <Dropdown
          :options="usersTV"
          class="m2"
          :selected="usersTV.find(t => t.value == task_template.sent_user)"
          :placeholder="$t('sent_user')"
          v-on:selectedChange="e => onDropdownChange('sent_user', e)"
          :listHeight="120"
          box
        ></Dropdown>
        <Dropdown
          :options="localDetailTypesTV"
          class="m2"
          :selected="localDetailsTypeSelectedTV"
          :placeholder="$t('display_local_details')"
          v-on:selectedChange="e => onDropdownChange('local_detail_type_ids', e)"
          :listHeight="120"
          box
          multiple
        ></Dropdown>
        <div class="dt-checkbox-control" style="height: 25px; margin: 0px">
          <div class="dt-checkbox v2 s1">
            <input
              type="checkbox"
              :name="'travel'"
              :id="'travel'"
              :checked="task_template.travel == '1'"
              @click="e => onCheckboxChange('travel', e)"
            />
            <div class="checkmark"></div>
          </div>
          <div class="dt-checkbox-label">{{$t('show_travel')}}</div>
        </div>

        <!-- <Checkbox2
          style="flex:1"
          :disabled="false"
          :id="'travel'"
          :label="'Delete Task if Artist is cancelled'"
          :checked="false"
          :value="1"
          :placeholder="'Delete Task if Artist is cancelled'"
          :lw="'115px'"
          @input="onDropdownChange"
          :bb="'none'"
        /> -->
        
        <div class="dt-checkbox-control" style="height: 25px; margin: 0px">
          <div class="dt-checkbox v2 s1">
            <input
              type="checkbox"
              :name="'delete_on_cancel'"
              :id="'delete_on_cancel'"
              :checked="task_template.delete_on_cancel == '1'"
              @click="e => onCheckboxChange('delete_on_cancel', e)"
            />
            <div class="checkmark"></div>
          </div>
          <div class="dt-checkbox-label">{{$t('delete_task_if_artist_is_cancelled')}}</div>
        </div>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onTaskTemplateSubmit">
        {{ $t("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { BookingSettingsService } from "../../services/booking-settings.service";

export default {
  components: {
    Modal
  },
  props: {},
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      },
      task_template: this.getTaskTemplate(),
      submitted: false,
      formData: {}
    };
  },
  mounted: async function() {
    const formData = await BookingSettingsService.findBookingTaskTemplateFormData({ task_template_id: this.task_template_id });
    this.formData = formData.data;

    if (this.isEditMode) {
      this.task_template = this.formData.task_template;
    } else {
      this.task_template = this.getTaskTemplate();
    }
  },
  computed: {
    task_template_id: function() {
      return this.$route.query.task_template_id;
    },
    mode: function() {
      return this.$route.query.mode;
    },
    isEditMode: function() {
      return this.mode == "edit";
    },
    loadingFlag: function() {
      if (this.isEditMode) {
        return !this.task_template.task_template_id;
      } else {
        return this.submitted;
      }
    },
    usersTV(){
      return (this.formData?.all_users || []).map(r => ({text: r.user_name, value: r.user_id}));
    },
    localDetailTypesTV(){
      return (this.formData?.local_detail_types || []).map(r => ({text: r.local_details_type_name, value: r.local_details_type_id}));
    },
    assignedUserSelectedTV(){
      const assignedUserArr = this.task_template?.assigned_user ? this.task_template.assigned_user.split(',') : [];
      return this.usersTV.filter( userTV => assignedUserArr.includes("" + userTV.value) ) || [];
    },
    localDetailsTypeSelectedTV(){
      const ldtArr = this.task_template?.local_detail_type_ids ? this.task_template.local_detail_type_ids.split(',') : [];
      return this.localDetailTypesTV.filter( ldtTV => ldtArr.includes("" + ldtTV.value) ) || [];
    }
  },
  methods: {
    onTaskTemplateSubmit: function() {
      this.submitted = true;
      this.$emit("done", {
        mode: this.mode,
        task_template: this.task_template
      });
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function(id, value) {
      this.task_template[id] = value;
    },
    onDropdownChange: function(name, value) {
      let val = value.value;
      if(['assigned_user', 'local_detail_type_ids'].includes(name)){
        val = value.map(r => r.value).join();
      }
      this.task_template[name] = val;
    },
    onCheckboxChange: function(name, event) {
      this.task_template[name] = event.target.checked ? "1" : "0";
    },
    getTaskTemplate: function() {
      return {
        task_template_name: "",
        day_shift: "",
        assigned_user: "",
        sent_user: "",
        local_detail_type_ids: "",
        travel: "",
        delete_on_cancel: ""
      };
    }
  }
};
</script>

<style lang="scss">
.cmp-settings-task-template-form {
  .dt-checkbox-control {
    display: flex;
    padding-top: 12px;
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }
}
</style>
